import { RefreshButton } from '@/shared/components/ui/refresh-button'
import { ServiceCatalog } from './components/ServiceCatalog'
import { usePackageCatalog } from './hooks/usePackageCatalog'

/**
 * Uso 1 — sección pública del sidebar. Vista informativa del catálogo, sin
 * selección. Para contratar se hace desde un negocio.
 */
export function ServicesPage() {
  // Mismo query que `ServiceCatalog` (Apollo deduplica): aquí solo para el refresh.
  const { refetch } = usePackageCatalog()

  return (
    <div className="space-y-6">
      <header className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h1 className="font-serif text-[36px] font-normal leading-[1.1] tracking-tight text-ink">
            Nuestros servicios
          </h1>
          <p className="mt-1 text-sm text-ink-muted">
            Explora todo lo que puedes contratar para tus negocios.
          </p>
        </div>
        <RefreshButton onClick={async () => { await refetch() }} />
      </header>

      <ServiceCatalog mode="view" />
    </div>
  )
}
